import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fbf9330e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf9330e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf9330e')) {
      api.createRecord('fbf9330e', component.options)
    } else {
      api.reload('fbf9330e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fbf9330e&scoped=true&lang=pug", function () {
      api.rerender('fbf9330e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/footer/index.vue"
export default component.exports